import { Paper, styled } from '@mui/material';

export const ProgramLessonListWrap = styled(Paper)({
	borderRadius: '20px',
	padding: '16px',
	flex: 1,
});

export const ProgramLessonList = styled('div')({
	margin: 0,
	padding: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '8px',
});

export const StyledLessonItemWrap = styled(Paper)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: '8px 16px',
	gap: '24px',
	width: '100%',
	borderRadius: '10px',
	cursor: 'pointer',
	WebkitTapHighlightColor: 'transparent',

	[theme.breakpoints.down('sm')]: {
		padding: '8px',
	},
}));

export const StyledLessonItemInnerWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '24px',
	flex: 1,

	[theme.breakpoints.down('xs')]: {
		gap: '12px',
	},
}));

export const StyledLessonItemImage = styled('img')(({ theme }) => ({
	borderRadius: '4px',
	height: '32px',
	width: '64px',
	maxWidth: '100%',
	objectFit: 'cover',
	objectPosition: 'center',

	pointerEvents: 'none',

	[theme.breakpoints.down('sm')]: {
		width: '60px',
		height: '40px',
	},
}));
